/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */

export function programNamesForCountries(
    programsByCountry: Record<string, unknown> | null | undefined,
    countryNames: readonly string[]
): string[] {
    if (!programsByCountry || countryNames.length === 0) {
        return [];
    }

    const names = new Set<string>();
    for (const country of countryNames) {
        const programs = programsByCountry[country];
        if (!Array.isArray(programs)) {
            continue;
        }
        for (const program of programs) {
            if (typeof program === 'string' && program) {
                names.add(program);
            }
        }
    }
    return [...names].sort();
}

export const transformProgramsToResults = (
    rawData: any[] | null | undefined,
    allowedCountries: readonly string[],
    limit?: number
) => {
    const allowed = new Set(allowedCountries);

    return (rawData ?? [])
        .filter((country) => allowed.has(country?.country))
        .map((country) => ({
            name: country.country,
            flag: country.country,
            streams: (limit
                ? country.eligible_programs.slice(0, limit)
                : country.eligible_programs
            ).map((program: any) => ({
                title: program.program_name,
                type: program.program_type,
                score: program.summary?.score || 0,
                max_score: program.summary?.max_score,
                passed: program.summary?.passed,
            })),
        }));
};
